<template>
  <div>
    <div :id="componentId+'-plot_area'" class="row">
    </div>
    <div class="align-content-center">
      <b-button :disabled="disable" size="sm" variant="info" v-on:click="prevPage">Prev</b-button>
      <b-button :disabled="disable" size="sm" class="ml-2" variant="info" v-on:click="nextPage">Next</b-button>
    </div>
  </div>
</template>


<script>
/* eslint-disable */
import * as d3 from "d3";
import {loadingCircle} from "../mixins/D3Mixin";


export default {
  name: "NormalizedBarChartWidget",
  props: ["plotData", "componentId", "barnumber", "page", "advanced"],
  mixins: [loadingCircle],
  data() {
    return {
      divId : this.componentId + '-plot_area',
      disable: false
    }
  },

  watch: {
    plotData() {
      this.drawBarChart(1)
      this.disableButton()
    },
    page() {
      this.drawBarChart(this.page)
    },
    barnumber() {
      this.drawBarChart(this.page)
    }
  },

  mounted() {
    this.initSvg()
  },

  methods: {
    nextPage() {
      if (this.page < (this.plotData.data[0].values.length / this.barnumber)) {
        this.page += 1;
      }
    },
    prevPage() {
      if (this.page > 1) {
        this.page -= 1
      }
    },

    disableButton() {
      this.disable = this.plotData.data.length[0] <= this.barnumber;
    },
    initSvg() {
      this.divElement = document.getElementById(this.divId)
      this.drawBarChart(this.page)
    },
    drawBarChart(page) {
      if (this.divElement.childNodes.length > 0) {
        while (this.divElement.firstChild) {
          this.divElement.removeChild(this.divElement.lastChild);
        }
      }
      let margin = {top: 20, right: 20, bottom: 30, left: 40},
          width = 350 - margin.left - margin.right,
          height = 198 - margin.top - margin.bottom;

      if (this.plotData === null) {
        this.spinningCircle(margin, width, height)
      } else {
        if (this.plotData.length !== 0) {
          let plotData = this.plotData
          let cssCol = "col-12"
          let sub_legend = false
          let svg_numbers = this.plotData.length
          if (this.plotData.data.length >= 2) {
            cssCol = "col-6"
          }
          if (this.advanced === "checked") {
            sub_legend = true
          }

          const subgroups = plotData.columns
          let divElement = this.divElement
          let barnumber = this.barnumber
          this.plotData.data.forEach(function (split, index) {
            let viewdata = split.values.slice((page - 1) * barnumber, page * barnumber);
            const margin = {
                  top: 20,
                  right: subgroups.reduce((t, d) => d.length > t ? d.length : t, 0) * 6 + 25,
                  bottom: 50,
                  left: 40
                }, width = 500 - margin.left - margin.right,
                height = width * 0.8 - margin.top - margin.bottom;

            // append the svg object to the body of the page

            const svg = d3.select(divElement)
                .append("svg")
                .attr("class", cssCol)
                .attr("viewBox", `0 0 ${width + margin.left + margin.right} ${height + margin.top + margin.bottom}`)
                .append("g")
                .attr("transform",
                    `translate(${margin.left},${margin.top})`);


            // List of subgroups = header of the csv files = rank group condition here

            // List of groups = event here = value of the first column called group -> I show them on the X axis
            const groups = viewdata.map(d => d.group)

            // Add X axis
            const x = d3.scaleBand()
                .domain(groups)
                .range([0, width])
                .padding([0.2])
            svg.append("g")
                .call(d3.axisBottom(x).tickSizeOuter(0))
                .attr("transform", `translate(0,${height})`)
                .selectAll("text")
                .style("text-anchor", "end")
                .attr("dx", "-.7em")
                .attr("dy", ".13em")
                .attr("transform", "rotate(-30)");

            // Add Y axis
            const y = d3.scaleLinear()
                .domain([0, 100])
                .range([height, 0]);
            svg.append("g")
                .call(d3.axisLeft(y));

            // color palette = one color per subgroup
            const color = d3.scaleOrdinal()
                .domain(subgroups)
                .range(['#e6194B', '#3cb44b', '#ffe119', '#4363d8', '#f58231', '#911eb4', '#42d4f4', '#f032e6', '#bfef45',
                  '#fabed4', '#469990', '#dcbeff', '#9A6324', '#fffac8', '#800000', '#aaffc3', '#808000', '#ffd8b1',
                  '#000075', '#a9a9a9', '#ffffff', '#000000'])


            let dataNormalized = []
            viewdata.forEach(d => {
              // Compute the total
              let tot = 0
              for (let i in subgroups) {
                let name = subgroups[i];
                tot += +d[name]
              }
              // Now normalize
              for (let i in subgroups) {
                let name = subgroups[i];
                d[name] = d[name] / tot * 100
              }
            })

            //stack per subgroup
            const stackedData = d3.stack()
                .keys(subgroups)
                (viewdata)


            // Show the bars
            svg.append("g")
                .selectAll("g")
                .data(stackedData)
                .join("g")
                .attr("fill", d => color(d.key))
                .selectAll("rect")
                // enter a second time = loop subgroup per subgroup to add all rectangles
                .data(d => d)
                .join("rect")
                .attr("x", d => x(d.data.group))
                .attr("y", d => y(d[1]))
                .attr("height", d => y(d[0]) - y(d[1]))
                .attr("width", x.bandwidth())

            if (sub_legend) {

              svg.append("text")
                  .attr('x', width / 2 - 15)
                  .attr('y', function (d, i) {
                    return (i * 12) + height + 45;
                  })
                  .text(split.group)
                  .attr('text-anchor', 'start')
                  .style("font-size", "15px")
                  .attr("alignment-baseline", "middle")
            }
            let legend
            if (index === 0) {
              if (plotData.data.length > 1) {
                const svglegend = d3.select(divElement)
                    .append("svg")
                    .attr("class", cssCol)
                    .attr("viewBox", `0 0 ${width + margin.left + margin.right} ${height + margin.top + margin.bottom}`)
                    .append("g")
                    .attr("transform",
                        `translate(${margin.left},${margin.top})`);

                legend = svglegend.append('g')
                    .attr('class', 'legend')
                    .attr('transform', `translate(0, 0)`);
              }
              else {
                legend = svg.append('g')
                    .attr('class', 'legend')
                    .attr('transform', `translate(${width + 10}, 0)`);
              }

              legend.selectAll('rect')
                  .data(subgroups)
                  .enter()
                  .append('rect')
                  .attr('x', 0)
                  .attr('y', (d, i) => i * 12)
                  .attr('width', 10)
                  .attr('height', 10)
                  .attr('fill', (d) => color(d));

              legend.selectAll('text')
                  .data(subgroups)
                  .enter()
                  .append('text')
                  .text(d => d)
                  .attr("font-size", "8px")
                  .attr('x', 14)
                  .attr('y', (d, i) => i * 12 + 1.5)
                  .attr('text-anchor', 'start')
                  .attr('alignment-baseline', 'hanging');

            }


          })
        } else {
          this.notEnoughData(margin, width, height)
        }

      }
    }
  }
}
</script>

<style scoped>

</style>